import EditMyAccount, { EditMyAccountRef } from "@/pages/EditMyAccount";
import DocumentMasterTab, {
  Document,
  DocumentMasterTabRef,
} from "../../DocumentMasterTab";
import { memo } from "react";
import FinOb1View from "./FinOb1View";
import { DocumentApprovalStatus } from "@/constants/enums/document-approval-status.enum";

export interface DocumentMaster {
  id: number;
  title: string;
  description: string;
  sequence: number;
  folder_id: number;
  documents: Document[];
  status?: any | boolean | DocumentApprovalStatus | null;
}

export interface DocumentMasterResponse {
  data: {
    financial: DocumentMaster[];
    legal: DocumentMaster[];
  };
  message: string;
}

interface TabContentProps {
  userId?: string;
  activeTab: number;
  activeFinOB: number;
  documentMaster: DocumentMasterResponse["data"];
  formRef: React.RefObject<EditMyAccountRef>;
  documentMasterTabRef: React.RefObject<DocumentMasterTabRef>;
  forceRefresh: boolean;
  setForceRefresh: (value: boolean) => void;
  nextTab: () => void;
  handleValidatingProfile: () => void;
  isTableView?: boolean;
  isTimeline?: boolean;
  documents?: Document[];
}

const TabContent = memo<TabContentProps>(
  ({
    userId,
    activeTab,
    activeFinOB,
    documentMaster,
    formRef,
    documentMasterTabRef,
    forceRefresh,
    setForceRefresh,
    nextTab,
    handleValidatingProfile,
    isTableView = false,
    isTimeline = false,
    documents,
  }) => {
    if (activeTab === 0 && activeFinOB === 0) {
      return (
        <>
          {isTableView || isTimeline ? (
            <FinOb1View
              userId={userId}
              isTimeline={isTimeline}
              documents={documentMaster.financial[activeFinOB].documents}
              description={documentMaster.financial[activeFinOB].description}
              status={
                documentMaster.financial[activeFinOB].documents[0]
                  .uploaded_document.status
              }
              forceRefresh={forceRefresh}
              setForceRefresh={setForceRefresh}
            />
          ) : (
            <div>
              <h2 className="tw-text-md tw-font-semibold">
                {documentMaster.financial[activeFinOB].description}
              </h2>
              <EditMyAccount
                hideSubmitButton={true}
                hideDefaultHeader={true}
                customSubmitHandler={nextTab}
                className="tw-space-y-4"
                ref={formRef}
                userDataAvailableCallback={handleValidatingProfile}
                isRequest={false}
              />
            </div>
          )}
        </>
      );
    }

    return (
      <DocumentMasterTab
        ref={documentMasterTabRef}
        {...(activeTab === 0
          ? documentMaster.financial[activeFinOB]
          : documentMaster.legal[activeFinOB])}
        forceRefresh={forceRefresh}
        setForceRefresh={setForceRefresh}
        isTableView={isTableView}
        isTimeline={isTimeline}
      />
    );
  },
);

TabContent.displayName = "TabContent";

export default TabContent;
